<template>
  <div class="has_market_price">
    <!-- <Header /> -->
    <section
      id="inventory"
      class="pt-5 pb-5 text-white"
      style="background-image:url(/assets/images/bg/aggregator-details-bg.jpg); background-position: center center; background-size:cover; background-repeat: no-repeat"
    >
      <div class="d-flex justify-content-center text-center my-3">
        <router-link to="/aggregator" class="btn btn-black btn-pill m-2"
          >Aggregator</router-link
        >
      </div>
    </section>

    <section class="table-section px-3 mt-3">
      <div class="container-fluid px-0" style="min-width:100%">
        <div class="row mb-5">
          <div class="col-md-4 col-lg-3">
            <div class="bg-success rounded-lg pt-5 pb-3">
              <div class="px-4 text-white" v-if="type == 'aggregator'">
                <h5 class="mb-3">
                  Aggregator
                </h5>

                <p>
                  The aggregator tool helps put together the supply, when you
                  register as an aggregator, your job description would include
                  aggregation in rural settlements, to help aggregate produce
                  from farmers. Do you live in farming community or knwo someone
                  who does? Sign up as aaggregator and earn on produce
                  aggregated.
                </p>

                <p>
                  When you Sign up as an aggregator or any other field on the
                  Aggregator tool you agree to our
                  <router-link to="/legal">Terms and Conditions</router-link>
                </p>
              </div>

              <div class="px-4 text-white" v-if="type == 'farmer'">
                <h5 class="mb-3">
                  Farmer
                </h5>

                <p>
                  As a farmer, the aggregator tool helps you list all of your
                  harvest on the market place, when you register as a farmer,
                  you have access to the best markets as individual and
                  businesses can buy all of your harvest at fair market value.
                </p>
                <p>
                  Are you are farmer? Or do you know one? Sign up as a farmer,
                  and gain access to the best markets.
                </p>

                <p>
                  When you Sign up as a farmer or any other field on the
                  Aggregator tool you agree to our
                  <router-link to="/legal">Terms and Conditions</router-link>
                </p>
              </div>

              <div class="px-4 text-white" v-if="type == 'trader'">
                <h5 class="mb-3">
                  Trader
                </h5>

                <p>
                  The aggregator tool helps you the trader list all of your
                  commodities on the market place, when you register as a
                  trader, you have access to the best markets as individual and
                  businesses can buy all of your commodities at fair market
                  value.
                </p>
                <p>
                  Are you are trader? Or do you know one? Sign up as a trader,
                  and gain access to the best markets.
                </p>

                <p>
                  When you Sign up as a trader or any other field on the
                  Aggregator tool you agree to our
                  <router-link to="/legal">Terms and Conditions</router-link>
                </p>
              </div>

              <div class="px-4 text-white" v-if="type == 'input'">
                <h5 class="mb-3">
                  Input Provider
                </h5>

                <p>
                  The aggregator tool helps you the list all of your inputs on
                  the market place, when you register as a Inputs provider, you
                  have access to the best markets as individual farmers,
                  corporatives, and large scale farmers can buy or rent all of
                  your inputs, from seeds, to fertilizers, machinery etc at fair
                  market value.
                </p>
                <p>
                  Are you are Input provider? Or do you know one? Sign up as a
                  Input provider? , and gain access to the best markets.
                </p>

                <p>
                  When you Sign up as a Input provider? or any other field on
                  the Aggregator tool you agree to our
                  <router-link to="/legal">Terms and Conditions</router-link>
                </p>
              </div>

              <div class="px-4 text-white" v-if="type == 'logistics'">
                <h5 class="mb-3">
                  Logistics Partner
                </h5>

                <p>
                  The aggregator tool helps you the list all of your Trucks,
                  ships, and other related assets on the market place, we'd
                  assign your assets to an ever increasing number of orders to
                  help move produce when you register as a Logistics partner,
                  you have access to the widest pool of orders, as our retail,
                  wholesale, institutional clients and exporter seek to move
                  produce.
                </p>
                <p>
                  Are you a logistics solutions provider? Or do you know one?
                  Sign up as a Logistics partner? , and gain access to the best
                  markets.
                </p>

                <p>
                  When you Sign up as a Logistics provider? or any other field
                  on the Aggregator tool you agree to our
                  <router-link to="/legal">Terms and Conditions</router-link>
                </p>
              </div>

              <div class="px-4 text-white" v-if="type == 'warehouse'">
                <h5 class="mb-3">
                  Warehouse Providers
                </h5>

                <p>
                  The aggregator tool helps you the list all of your warehouses
                  on the market place, when you register as a Warehouse
                  provider, you have access to the best markets as individual
                  farmers, corporatives, and large scale farmers can buy or rent
                  all of your spaces, for a variety of usage, for a defined
                  period of time at the best rates.
                </p>
                <p>
                  Do you own a warehouse? have managerial access to one?, do you
                  know someone who does? Sign up as a Warehouse provider? , and
                  gain access to the best markets.
                </p>

                <p>
                  When you Sign up as a Warehouse provider? or any other field
                  on the Aggregator tool you agree to our
                  <router-link to="/legal">Terms and Conditions</router-link>
                </p>
              </div>

              <div class="px-4 text-white" v-if="type == 'processor'">
                <h5 class="mb-3">
                  Processor
                </h5>

                <p>
                  The aggregator tool helps you the list all of your products on
                  the market place, when you register as a processor, you have
                  access to the best markets as individuals, corporatives,
                  household managers, retailers, wholesalers, institutional
                  clients, and other can buy all of your products.
                </p>
                <p>
                  Are you are processor? Or do you know one? Sign up as a
                  processor? , and gain access to the best markets.
                </p>

                <p>
                  When you Sign up as a Processor? or any other field on the
                  Aggregator tool you agree to our
                  <router-link to="/legal">Terms and Conditions</router-link>
                </p>
              </div>

              <div class="d-flex justify-content-center text-center my-3">
                <router-link to="/login" class="btn btn-black btn-pill m-2"
                  >LogIn</router-link
                >
                <router-link to="/signup" class="btn btn-black btn-pill m-2"
                  >Sign Up</router-link
                >
              </div>
            </div>
          </div>
          <div class="col-md-8 col-lg-9">
            <div
              class="d-flex h-100 justify-content-center align-items-center border border-dark rounded-lg p-5"
            >
              <div>
                <h6>
                  INPUTS: PLEASE CALL FIELDS FROM API SAME FOR OTHER FIELDS
                </h6>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <market-price />
  </div>
</template>

<script>
// import Header from "@/components/Header.vue";
import MarketPrice from "@/components/MarketPrice.vue";
export default {
  metaInfo: {
    title: "Quickleap",
    titleTemplate: "%s | Aggregator Details Page",
    htmlAttrs: {
      lang: "en",
      amp: true
    }
  },
  components: { MarketPrice },
  beforeCreate() {
    let ag_type = this.$route.params.type;
    let aggregators = [
      "aggregator",
      "farmer",
      "trader",
      "input",
      "logistics",
      "warehouse",
      "processor"
    ];
    !aggregators.includes(ag_type) && this.$router.push("/");
  },
  data() {
    return {
      type: this.$route.params.type,
      aggregators: [
        "aggregator",
        "farmer",
        "trader",
        "input",
        "logistics",
        "warehouse",
        "processor"
      ]
    };
  }
};
</script>
